import { inject, Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { SsApiService } from './api/ss-api.service';
import { CookieService } from 'ngx-unificator/services';
import { PlatformService } from './platform.service';
import { ROOT_LANG } from '../helpers/router';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private _api = inject(SsApiService);
  private _cookie = inject(CookieService);
  private _platform = inject(PlatformService);


  private _currentLanguage: any;
  private _currentRouteLanguage: string = '';

  private _langChange$: ReplaySubject<string> = new ReplaySubject<string>(1);
  private readonly INITIAL_LANG: string = ROOT_LANG;
  private _prevLanguage: string = this.INITIAL_LANG;

  public rightLocales = {
    rtCurrencies: ['EUR', '€'],
    rtLanguages: ['de', 'de-at'],
  };

  get previous(): string {
    return this._prevLanguage;
  }

  get current(): string {
    return this._currentLanguage;
  }

  public get currentRouteLanguage(): string {
    return this._currentRouteLanguage;
  }

  get langChange$(): ReplaySubject<string> {
    return this._langChange$;
  }

  /**
   * Change website lang to provided
   *
   * @param lang
   */
  changeLang(lang: string) {
    if (lang !== this._currentLanguage) {
      this._updateLocale(lang);
      this._prevLanguage = this._currentLanguage;
      this._currentLanguage = lang;
      this._currentRouteLanguage = lang !== ROOT_LANG ? lang : '';
      this._langChange$.next(this._currentLanguage);
      this._cookie.set('lang', lang, 99, '/');
    }
  }

  /**
   * Send update_locale request
   *
   * @private
   */
  private _updateLocale(locale: string) {
    const parts = locale.split('-');
    if (parts[1]) parts[1] = parts[1].toUpperCase();

    // @ts-ignore
    this._api.playerUpdateLocale({
      locale: parts[1] === 'EU' ? 'en' : parts.join('-'),
    }).subscribe();
  }

  public detectUserLang(routeLang: string, envLang: string, langList: any[]): string {
    const browserLang = this._platform.isBrowser ? navigator.languages.find(lang => this._langExists(lang.toLowerCase(), langList)) : ROOT_LANG;
    const cookieLang = this._cookie.get('lang');

    let definedLang = this.INITIAL_LANG;

    if (browserLang) {
      definedLang = browserLang.toLowerCase();
    }

    if (this._platform.isBrowser && envLang && this._langExists(envLang, langList)) {
      definedLang = envLang;
    }

    if (cookieLang && this._langExists(cookieLang, langList)) {
      definedLang = cookieLang;
    }

    if (routeLang && this._langExists(routeLang, langList)) {
      definedLang = routeLang;
    }

    return definedLang;
  }

  /**
   * Is provided lang available
   *
   * @param lang
   * @param list
   * @private
   */
  private _langExists(lang: string, list: { short: string }[]): boolean {
    return list?.some(available => available.short === lang);
  }
}
